import { AlertTriangle, CircleCheck, CircleX, type LucideIcon } from 'lucide-react';
import { cn } from '@/lib/utils';
import type { SendOutcome, SendTone } from './sendOutcome';

const TONES: Record<SendTone, { icon: LucideIcon; className: string }> = {
  success: { icon: CircleCheck, className: 'bg-success-soft text-success-soft-foreground' },
  warning: { icon: AlertTriangle, className: 'bg-warning-soft text-warning-soft-foreground' },
  error: { icon: CircleX, className: 'bg-destructive-soft text-destructive-soft-foreground' }
};

/**
 * What the last share send came to, as one line in the modal (DV-3715),
 * shared by every send. The live region stays mounted so a screen reader
 * hears each new outcome, not only the first.
 */
const SendOutcomeLine = ({ outcome }: { outcome: SendOutcome | null }) => {
  const tone = outcome === null ? null : TONES[outcome.tone];
  return (
    <div role="status" data-testid="send-outcome">
      {outcome !== null && tone !== null && (
        <div
          className={cn(
            'flex items-start gap-2 rounded-lg px-3 py-2 text-sm leading-5',
            tone.className
          )}
        >
          <tone.icon className="mt-0.5 h-4 w-4 shrink-0" aria-hidden />
          <span>{outcome.inline}</span>
        </div>
      )}
    </div>
  );
};

export default SendOutcomeLine;
